<template>
    <WarningDialog
        :showDialog="isOpen"
        :title="$t('message.familyAccounts.unlinkAccountTitle', { fullName })"
        :cancelCallback="onClose"
        :confirmCallback="onConfirm"
        :submitting="isSubmitting"
    >
        <template #default>
            <p class="text-left">
                {{
                    isValidEmail
                        ? $t(
                              'message.familyAccounts.unlinkAccountDescription',
                              { fullName }
                          )
                        : $t(
                              'message.familyAccounts.unlinkAccountDescriptionNoEmail',
                              { fullName }
                          )
                }}
            </p>
            <p class="text-left">
                <v-icon small color="secondary" class="mr-1">mdi-alert</v-icon>
                <span
                    v-html="
                        $t('message.familyAccounts.unlinkAccountWarningMessage')
                    "
                ></span>
            </p>
            <p v-if="isValidEmail" class="text-left">
                {{
                    $t(
                        'message.familyAccounts.unlinkAccountConfirmationMessage'
                    )
                }}
            </p>
            <template v-else>
                <v-label class="tw-text-sm">
                    <span class="tw-font-semibold">{{
                        $t('message.email')
                    }}</span>
                    <span class="tw-text-red-500 tw-ml-1">*</span>
                </v-label>
                <v-text-field outlined v-model="inputEmail" hide-details />
            </template>
        </template>
    </WarningDialog>
</template>

<script setup>
import WarningDialog from '../../../components/shared/WarningDialog.vue'
import { computed, ref } from 'vue'
import { isVibefamGeneratedEmail } from '../utils/subAccountUtils'
import { unlinkSubAccount } from '../api/subAccountsApi'
import { useI18n } from 'vue-i18n-composable'
import { useToast } from '@/components/base/toast/composable/useToast'

const { t } = useI18n()
const { showSuccessToast, showErrorToast } = useToast()

const { mainAccountId, user, isOpen, onClose, refresh } = defineProps({
    mainAccountId: String,
    user: {
        type: Object,
        default: {},
    },
    isOpen: Boolean,
    onClose: Function,
    refresh: Function,
})
const fullName = computed(() => {
    return user.fullName ?? ''
})
const inputEmail = ref('')
const isSubmitting = ref(false)

const isValidEmail = computed(() => {
    return user.email && !isVibefamGeneratedEmail(user.email)
})

const onConfirm = async () => {
    isSubmitting.value = true
    let result
    if (inputEmail.value) {
        result = await unlinkSubAccount(
            mainAccountId,
            user.id,
            inputEmail.value
        )
    } else {
        result = await unlinkSubAccount(mainAccountId, user.id)
    }
    isSubmitting.value = false
    if (result.error) {
        showErrorToast(result.error)
    } else {
        onClose()
        refresh()
        showSuccessToast(
            t('message.familyAccounts.unlinkAccountSuccessMessage', {
                fullName: user.fullName,
            })
        )
    }
}
</script>
